import { createSelector } from 'reselect';
import { getLatestActivitySet } from 'lib/selectors/getLatestActivitySet';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';

const getHasOpenActivitySet = createSelector(
  [getLatestActivitySet, getCurrentLaborTicket, getPostLaborUpdatesOnNats],
  (latestActivitySet, currentLaborTicket, natsFlowEnabled) => {
    // Moved this branch to the top because NATS open/closed state comes from the labor ticket first.
    // NATS flow: activity set is "open" based on labor ticket state
    if (natsFlowEnabled) {
      if (currentLaborTicket?.state === 'OPEN') {
        return true;
      }

      if (currentLaborTicket?.state === 'CLOSED') {
        const endBehavior = currentLaborTicket?.customFields?.endBehavior;
        // Keep activity set open if endBehavior is 'keep-open' (paused setup or operator signed out)
        return endBehavior === 'keep-open';
      }

      return false;
    }

    const hasOpenActivitySet = !!(
      latestActivitySet && latestActivitySet.closedAt === null
    );

    if (!hasOpenActivitySet) {
      return false;
    }

    // Standard flow: check actual activity set
    return true;
  }
);

export { getHasOpenActivitySet };
